import { GraphQLResolveInfo, GraphQLScalarType, GraphQLScalarTypeConfig } from 'graphql';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type RequireFields<T, K extends keyof T> = Omit<T, K> & { [P in K]-?: NonNullable<T[P]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  JSON: { input: any; output: any; }
  JSONObject: { input: any; output: any; }
  Unknown: { input: unknown; output: unknown; }
};

export type Address = {
  __typename?: 'Address';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  line1?: Maybe<Scalars['String']['output']>;
  postal?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
};

export type Answer = {
  __typename?: 'Answer';
  blocklistValue?: Maybe<Array<Scalars['JSONObject']['output']>>;
  booleanValue?: Maybe<Scalars['Boolean']['output']>;
  booleanlistValue?: Maybe<Array<Scalars['Boolean']['output']>>;
  numericValue?: Maybe<Scalars['Float']['output']>;
  numericlistValue?: Maybe<Array<Scalars['Float']['output']>>;
  textValue?: Maybe<Scalars['String']['output']>;
  textlistValue?: Maybe<Array<Scalars['String']['output']>>;
};

export type AnswerInput = {
  blocklistValue?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  booleanValue?: InputMaybe<Scalars['Boolean']['input']>;
  booleanlistValue?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  numericValue?: InputMaybe<Scalars['Float']['input']>;
  numericlistValue?: InputMaybe<Array<Scalars['Float']['input']>>;
  textValue?: InputMaybe<Scalars['String']['input']>;
  textlistValue?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum AuthMode {
  LegacyTenant = 'LEGACY_TENANT',
  SaasOrganization = 'SAAS_ORGANIZATION'
}

export type Category = Node & {
  __typename?: 'Category';
  _id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  parent?: Maybe<Category>;
};

export type CloudinaryUploadSignature = {
  __typename?: 'CloudinaryUploadSignature';
  public_id: Scalars['String']['output'];
  signature: Scalars['String']['output'];
  timestamp: Scalars['Int']['output'];
};

export type Company = Node & SanityDocument & {
  __typename?: 'Company';
  _createdAt: Scalars['String']['output'];
  _id: Scalars['ID']['output'];
  _rev: Scalars['String']['output'];
  _type: Scalars['String']['output'];
  _updatedAt: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type CompanyConnection = Connection & {
  __typename?: 'CompanyConnection';
  edges?: Maybe<Array<CompanyEdge>>;
  pageInfo: PageInfo;
};

export type CompanyEdge = Edge & {
  __typename?: 'CompanyEdge';
  cursor: Scalars['String']['output'];
  node: Company;
};

export type CompleteOtpLoginResponse = {
  __typename?: 'CompleteOtpLoginResponse';
  cookies?: Maybe<Array<CookieValue>>;
  success: Scalars['Boolean']['output'];
};

export type Connection = {
  edges?: Maybe<Array<Edge>>;
  pageInfo: PageInfo;
};

export type Context = Node & {
  __typename?: 'Context';
  _id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type CookieValue = {
  __typename?: 'CookieValue';
  expires?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  path?: Maybe<Scalars['String']['output']>;
  sameSite?: Maybe<Scalars['String']['output']>;
  secure?: Maybe<Scalars['Boolean']['output']>;
  value: Scalars['String']['output'];
};

export type CookieValueInput = {
  domain?: InputMaybe<Scalars['String']['input']>;
  expires?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  path?: InputMaybe<Scalars['String']['input']>;
  sameSite?: InputMaybe<Scalars['String']['input']>;
  secure?: InputMaybe<Scalars['Boolean']['input']>;
  value: Scalars['String']['input'];
};

export type CreateOrganizationInput = {
  auth0_region: Scalars['String']['input'];
  auth0_tenant: Scalars['String']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  logo?: InputMaybe<SanityImageInput>;
  name: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['String']['input']>;
  organizationManagerEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  organizationManagerUsers?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type Edge = {
  cursor: Scalars['String']['output'];
  node: Node;
};

export enum ErrorCodes {
  AuthCodeInvalidOrExpired = 'AUTH_CODE_INVALID_OR_EXPIRED',
  AuthRequestFailed = 'AUTH_REQUEST_FAILED',
  BadRequest = 'BAD_REQUEST',
  CategoryAlreadyExists = 'CATEGORY_ALREADY_EXISTS',
  CategoryCouldNotBeUpdated = 'CATEGORY_COULD_NOT_BE_UPDATED',
  CategoryCreationFailed = 'CATEGORY_CREATION_FAILED',
  CategoryFetchFailed = 'CATEGORY_FETCH_FAILED',
  CategoryNotFound = 'CATEGORY_NOT_FOUND',
  CompanyAlreadyExists = 'COMPANY_ALREADY_EXISTS',
  CompanyCouldNotBeUpdated = 'COMPANY_COULD_NOT_BE_UPDATED',
  CompanyCreationFailed = 'COMPANY_CREATION_FAILED',
  CompanyFetchFailed = 'COMPANY_FETCH_FAILED',
  CompanyNotFound = 'COMPANY_NOT_FOUND',
  ContentLockedByLiveSessionCreateNewItemInstead = 'CONTENT_LOCKED_BY_LIVE_SESSION_CREATE_NEW_ITEM_INSTEAD',
  EmailAlreadyExists = 'EMAIL_ALREADY_EXISTS',
  EvaluationAlreadyExists = 'EVALUATION_ALREADY_EXISTS',
  EvaluationCouldNotBeUpdated = 'EVALUATION_COULD_NOT_BE_UPDATED',
  EvaluationCreationFailed = 'EVALUATION_CREATION_FAILED',
  EvaluationFetchFailed = 'EVALUATION_FETCH_FAILED',
  EvaluationNotFound = 'EVALUATION_NOT_FOUND',
  FailedToUnarchiveParticipant = 'FAILED_TO_UNARCHIVE_PARTICIPANT',
  Forbidden = 'FORBIDDEN',
  InternalServerError = 'INTERNAL_SERVER_ERROR',
  InvalidCategoryParent = 'INVALID_CATEGORY_PARENT',
  LocationAlreadyExists = 'LOCATION_ALREADY_EXISTS',
  LocationCouldNotBeUpdated = 'LOCATION_COULD_NOT_BE_UPDATED',
  LocationCreationFailed = 'LOCATION_CREATION_FAILED',
  LocationFetchFailed = 'LOCATION_FETCH_FAILED',
  LocationNotFound = 'LOCATION_NOT_FOUND',
  NotFound = 'NOT_FOUND',
  ObjectReferenced = 'OBJECT_REFERENCED',
  OrganizationCreationFailed = 'ORGANIZATION_CREATION_FAILED',
  OrganizationNeedsAuth0Id = 'ORGANIZATION_NEEDS_AUTH0_ID',
  OrganizationNotFound = 'ORGANIZATION_NOT_FOUND',
  ParticipantAlreadyExists = 'PARTICIPANT_ALREADY_EXISTS',
  ParticipantCreationFailed = 'PARTICIPANT_CREATION_FAILED',
  ParticipantFetchFailed = 'PARTICIPANT_FETCH_FAILED',
  ParticipantNotFound = 'PARTICIPANT_NOT_FOUND',
  ParticipantNotReady = 'PARTICIPANT_NOT_READY',
  PlanUpgradeRequired = 'PLAN_UPGRADE_REQUIRED',
  QuestionAlreadyExists = 'QUESTION_ALREADY_EXISTS',
  QuestionCouldNotBeUpdated = 'QUESTION_COULD_NOT_BE_UPDATED',
  QuestionCreationFailed = 'QUESTION_CREATION_FAILED',
  QuestionFetchFailed = 'QUESTION_FETCH_FAILED',
  QuestionNotFound = 'QUESTION_NOT_FOUND',
  ReportCouldNotBeUpdated = 'REPORT_COULD_NOT_BE_UPDATED',
  ReportCreationFailed = 'REPORT_CREATION_FAILED',
  ReportFetchFailed = 'REPORT_FETCH_FAILED',
  ReportNotFound = 'REPORT_NOT_FOUND',
  ScheduledSessionAlreadyExists = 'SCHEDULED_SESSION_ALREADY_EXISTS',
  ScheduledSessionCouldNotBeUpdated = 'SCHEDULED_SESSION_COULD_NOT_BE_UPDATED',
  ScheduledSessionCreationFailed = 'SCHEDULED_SESSION_CREATION_FAILED',
  ScheduledSessionFetchFailed = 'SCHEDULED_SESSION_FETCH_FAILED',
  ScheduledSessionNotFound = 'SCHEDULED_SESSION_NOT_FOUND',
  SessionAlreadyExists = 'SESSION_ALREADY_EXISTS',
  SessionCouldNotBeUpdated = 'SESSION_COULD_NOT_BE_UPDATED',
  SessionCreationFailed = 'SESSION_CREATION_FAILED',
  SessionFetchFailed = 'SESSION_FETCH_FAILED',
  SessionNotFound = 'SESSION_NOT_FOUND',
  SubscriptionExpired = 'SUBSCRIPTION_EXPIRED',
  SubscriptionInactive = 'SUBSCRIPTION_INACTIVE',
  SubscriptionLimitReached = 'SUBSCRIPTION_LIMIT_REACHED',
  SupplyobjectAlreadyExists = 'SUPPLYOBJECT_ALREADY_EXISTS',
  SupplyobjectCouldNotBeUpdated = 'SUPPLYOBJECT_COULD_NOT_BE_UPDATED',
  SupplyobjectCreationFailed = 'SUPPLYOBJECT_CREATION_FAILED',
  SupplyobjectFetchFailed = 'SUPPLYOBJECT_FETCH_FAILED',
  SupplyobjectNotFound = 'SUPPLYOBJECT_NOT_FOUND',
  TooManyRequests = 'TOO_MANY_REQUESTS',
  TrialLimitReached = 'TRIAL_LIMIT_REACHED',
  Unauthorized = 'UNAUTHORIZED',
  UserNotFound = 'USER_NOT_FOUND'
}

export type Evaluation = Node & {
  __typename?: 'Evaluation';
  _id: Scalars['ID']['output'];
  categories?: Maybe<Array<SanityBaseRef>>;
  context?: Maybe<SanityBaseRef>;
  description?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  options?: Maybe<EvaluationOptions>;
  questions?: Maybe<Array<SanityBaseRef>>;
  rCategories?: Maybe<Array<Category>>;
  rContext?: Maybe<Context>;
  rQuestions?: Maybe<Array<Question>>;
  totalMaxTime?: Maybe<Scalars['Int']['output']>;
};

export type EvaluationOptions = {
  __typename?: 'EvaluationOptions';
  enableTimer?: Maybe<Scalars['Boolean']['output']>;
};

export type Location = Node & {
  __typename?: 'Location';
  _id: Scalars['ID']['output'];
  address?: Maybe<Address>;
  name?: Maybe<Scalars['String']['output']>;
};

export type LogoutResponse = {
  __typename?: 'LogoutResponse';
  success: Scalars['Boolean']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  answerEvaluationQuestionStep?: Maybe<ScheduledSessionParticipantEntry>;
  applyCookie?: Maybe<Scalars['JSON']['output']>;
  completeAndCloseQuestionOrEvaluation?: Maybe<ScheduledSessionParticipantEntry>;
  completeOtpLogin?: Maybe<CompleteOtpLoginResponse>;
  completeSessionReportLogin?: Maybe<SessionReport>;
  /** @deprecated No longer supported */
  continueSession?: Maybe<ScheduledSessionParticipantEntry>;
  createOrganization?: Maybe<Organization>;
  getRealtimeToken?: Maybe<RealtimeToken>;
  logout: LogoutResponse;
  readyScheduledSession?: Maybe<ScheduledSessionParticipantEntry>;
  requestCloudinaryUploadSignature?: Maybe<CloudinaryUploadSignature>;
  requestHelp?: Maybe<ScheduledSessionParticipantEntry>;
  requestLogin?: Maybe<Scalars['Boolean']['output']>;
  sendErrorReport: SendErrorReportResponse;
  signupForScheduledSession?: Maybe<Scalars['Boolean']['output']>;
};


export type MutationAnswerEvaluationQuestionStepArgs = {
  answer: AnswerInput;
  evaluation: Scalars['ID']['input'];
  question: Scalars['ID']['input'];
  stepIndex: Scalars['Int']['input'];
};


export type MutationApplyCookieArgs = {
  cookie?: InputMaybe<CookieValueInput>;
};


export type MutationCompleteAndCloseQuestionOrEvaluationArgs = {
  evaluation: Scalars['ID']['input'];
  question?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationCompleteOtpLoginArgs = {
  loginCode: Scalars['String']['input'];
  otp: Scalars['String']['input'];
  tenant: Scalars['String']['input'];
  userIdentifier: UserIdentifierInput;
};


export type MutationCompleteSessionReportLoginArgs = {
  accessCode: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};


export type MutationContinueSessionArgs = {
  evaluation?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationCreateOrganizationArgs = {
  input: CreateOrganizationInput;
};


export type MutationGetRealtimeTokenArgs = {
  scheduledSession?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationRequestHelpArgs = {
  evaluation?: InputMaybe<Scalars['ID']['input']>;
  question?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationRequestLoginArgs = {
  loginCode: Scalars['String']['input'];
  tenant: Scalars['String']['input'];
  userIdentifier: UserIdentifierInput;
};


export type MutationSendErrorReportArgs = {
  input: SendErrorReportInput;
};


export type MutationSignupForScheduledSessionArgs = {
  loginCode: Scalars['String']['input'];
  participant: SignupParticipantInput;
  tenant: Scalars['String']['input'];
  userIdentifier: UserIdentifierInput;
};

export type Node = {
  _id: Scalars['ID']['output'];
};

export type Organization = SanityDocument & {
  __typename?: 'Organization';
  _createdAt: Scalars['String']['output'];
  _id: Scalars['ID']['output'];
  _rev: Scalars['String']['output'];
  _type: Scalars['String']['output'];
  _updatedAt: Scalars['String']['output'];
  auth0_region: Scalars['String']['output'];
  auth0_tenant: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  logo?: Maybe<SanityImage>;
  name: Scalars['String']['output'];
  organizationId?: Maybe<Scalars['String']['output']>;
  organizationManagerEmails?: Maybe<Array<Scalars['String']['output']>>;
  organizationManagerUsers?: Maybe<Array<Scalars['String']['output']>>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  hasPreviousPage?: Maybe<Scalars['Boolean']['output']>;
  pageSize?: Maybe<Scalars['Int']['output']>;
  startCursor?: Maybe<Scalars['String']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type Participant = Node & {
  __typename?: 'Participant';
  _id: Scalars['ID']['output'];
  email?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

export enum ParticipantSessionStatus {
  Active = 'ACTIVE',
  Completed = 'COMPLETED',
  HelpRequested = 'HELP_REQUESTED',
  Paused = 'PAUSED',
  Waiting = 'WAITING'
}

export type Query = {
  __typename?: 'Query';
  allCompanies: CompanyConnection;
  myScheduledSession?: Maybe<ScheduledSession>;
  myScheduledSessionParticipantEntry?: Maybe<ScheduledSessionParticipantEntry>;
  organizationTenantExists?: Maybe<Scalars['Boolean']['output']>;
};


export type QueryAllCompaniesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  tenant: Scalars['String']['input'];
};


export type QueryOrganizationTenantExistsArgs = {
  tenant: Scalars['String']['input'];
};

export type Question = Node & {
  __typename?: 'Question';
  _id: Scalars['ID']['output'];
  categories?: Maybe<Array<SanityBaseRef>>;
  maxTime?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  options?: Maybe<QuestionOptions>;
  rCategories?: Maybe<Array<Category>>;
  steps?: Maybe<Array<QuestionStep>>;
};

export type QuestionOptions = {
  __typename?: 'QuestionOptions';
  maxTime?: Maybe<Scalars['Int']['output']>;
};

export type QuestionStep = {
  __typename?: 'QuestionStep';
  _key: Scalars['String']['output'];
  answer?: Maybe<Answer>;
  question?: Maybe<Array<Scalars['JSONObject']['output']>>;
  score?: Maybe<Scalars['Float']['output']>;
  type?: Maybe<QuestionStepType>;
};

export enum QuestionStepType {
  Hotzone = 'HOTZONE',
  MultipleChoice = 'MULTIPLE_CHOICE',
  Numeric = 'NUMERIC',
  Practical = 'PRACTICAL',
  Text = 'TEXT'
}

export type RealtimeToken = {
  __typename?: 'RealtimeToken';
  capability: Scalars['String']['output'];
  clientId?: Maybe<Scalars['String']['output']>;
  expires: Scalars['Float']['output'];
  issued: Scalars['Float']['output'];
  token: Scalars['String']['output'];
};

export type SanityArrayElement = {
  _key: Scalars['String']['output'];
};

export type SanityAssetRef = {
  __typename?: 'SanityAssetRef';
  _ref: Scalars['String']['output'];
  _type: Scalars['String']['output'];
};

export type SanityAssetRefInput = {
  _ref: Scalars['String']['input'];
  _type: Scalars['String']['input'];
};

export type SanityBaseRef = SanityReference & {
  __typename?: 'SanityBaseRef';
  _ref: Scalars['String']['output'];
  _type: Scalars['String']['output'];
};

export type SanityDocument = {
  _createdAt: Scalars['String']['output'];
  _id: Scalars['ID']['output'];
  _rev: Scalars['String']['output'];
  _type: Scalars['String']['output'];
  _updatedAt: Scalars['String']['output'];
};

export type SanityImage = {
  __typename?: 'SanityImage';
  _type: Scalars['String']['output'];
  asset: SanityAssetRef;
};

export type SanityImageInput = {
  _type: Scalars['String']['input'];
  asset: SanityAssetRefInput;
};

export type SanityReference = {
  _ref: Scalars['String']['output'];
  _type: Scalars['String']['output'];
};

export type ScheduledSession = Node & SanityDocument & {
  __typename?: 'ScheduledSession';
  _createdAt: Scalars['String']['output'];
  _id: Scalars['ID']['output'];
  _rev: Scalars['String']['output'];
  _type: Scalars['String']['output'];
  _updatedAt: Scalars['String']['output'];
  autoAdvance?: Maybe<Scalars['Boolean']['output']>;
  datetime?: Maybe<Scalars['String']['output']>;
  options?: Maybe<ScheduledSessionOptions>;
  progress?: Maybe<Scalars['String']['output']>;
  rLocation?: Maybe<Location>;
  rSession?: Maybe<Session>;
  status?: Maybe<ScheduledSessionStatus>;
  timeLeft?: Maybe<Scalars['Int']['output']>;
  unlockableParticipantIds?: Maybe<Array<Scalars['String']['output']>>;
};

export type ScheduledSessionOptions = {
  __typename?: 'ScheduledSessionOptions';
  allQuestionsInEvaluationShownByDefault?: Maybe<Scalars['Boolean']['output']>;
  enableAutoPauseOnHelpRequest?: Maybe<Scalars['Boolean']['output']>;
};

export type ScheduledSessionParticipantEntry = Node & SanityDocument & {
  __typename?: 'ScheduledSessionParticipantEntry';
  _createdAt: Scalars['String']['output'];
  _id: Scalars['ID']['output'];
  _rev: Scalars['String']['output'];
  _type: Scalars['String']['output'];
  _updatedAt: Scalars['String']['output'];
  currentState?: Maybe<ScheduledSessionParticipantEntryCurrentState>;
  expectedEndTime?: Maybe<Scalars['String']['output']>;
  participant?: Maybe<SanityBaseRef>;
  ready?: Maybe<Scalars['Boolean']['output']>;
  reassignedEvaluationId?: Maybe<Scalars['ID']['output']>;
  sessionAnswers?: Maybe<Array<ScheduledSessionParticipantEntryAnswer>>;
  sessionOrder?: Maybe<Array<SanityBaseRef>>;
  sessionOverrides?: Maybe<Array<ScheduledSessionParticipantEntryOverride>>;
  sessionProgress?: Maybe<Array<ScheduledSessionParticipantEntryProgress>>;
  sessionStart?: Maybe<Scalars['String']['output']>;
  timeLeft?: Maybe<Scalars['Int']['output']>;
};

export type ScheduledSessionParticipantEntryAnswer = {
  __typename?: 'ScheduledSessionParticipantEntryAnswer';
  answers?: Maybe<Array<Answer>>;
  comment?: Maybe<Scalars['String']['output']>;
  evaluation?: Maybe<SanityBaseRef>;
  question?: Maybe<SanityBaseRef>;
};

export type ScheduledSessionParticipantEntryCurrentState = {
  __typename?: 'ScheduledSessionParticipantEntryCurrentState';
  _type?: Maybe<Scalars['String']['output']>;
  correctedEvaluationIds?: Maybe<Array<Scalars['ID']['output']>>;
  evaluation?: Maybe<SanityBaseRef>;
  finishedEvaluationIds?: Maybe<Array<Scalars['ID']['output']>>;
  isCurrentEvaluationEnded?: Maybe<Scalars['Boolean']['output']>;
  isReassigned?: Maybe<Scalars['Boolean']['output']>;
  lastUpdated?: Maybe<Scalars['String']['output']>;
  latestProgress?: Maybe<ScheduledSessionParticipantEntryProgress>;
  progressPercentage?: Maybe<Scalars['Float']['output']>;
  question?: Maybe<SanityBaseRef>;
  rEvaluation?: Maybe<Evaluation>;
  rQuestion?: Maybe<Question>;
  reassignedWithUnsubmittedCorrectionsEvaluationIds?: Maybe<Array<Scalars['ID']['output']>>;
  status?: Maybe<ParticipantSessionStatus>;
  stepIndex?: Maybe<Scalars['Int']['output']>;
  totalEvaluationsCount?: Maybe<Scalars['Int']['output']>;
};

export type ScheduledSessionParticipantEntryOverride = {
  __typename?: 'ScheduledSessionParticipantEntryOverride';
  datetime?: Maybe<Scalars['String']['output']>;
  evaluation?: Maybe<SanityBaseRef>;
  overrideType?: Maybe<SessionOverrideType>;
  question?: Maybe<SanityBaseRef>;
  rEvaluation?: Maybe<Evaluation>;
  rQuestion?: Maybe<Question>;
  stepIndex?: Maybe<Scalars['Int']['output']>;
  value?: Maybe<ScheduledSessionParticipantEntryOverrideValue>;
};

export type ScheduledSessionParticipantEntryOverrideValue = {
  __typename?: 'ScheduledSessionParticipantEntryOverrideValue';
  numericValue?: Maybe<Scalars['Float']['output']>;
  textValue?: Maybe<Scalars['String']['output']>;
};

export type ScheduledSessionParticipantEntryProgress = {
  __typename?: 'ScheduledSessionParticipantEntryProgress';
  evaluation?: Maybe<SanityBaseRef>;
  question?: Maybe<SanityBaseRef>;
  rEvaluation?: Maybe<Evaluation>;
  rQuestion?: Maybe<Question>;
  sectionEnd?: Maybe<Scalars['String']['output']>;
  sectionStart?: Maybe<Scalars['String']['output']>;
  timestamp?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export enum ScheduledSessionStatus {
  Active = 'ACTIVE',
  Canceled = 'CANCELED',
  Closed = 'CLOSED',
  Completed = 'COMPLETED',
  Draft = 'DRAFT',
  Open = 'OPEN',
  Paused = 'PAUSED'
}

export type SendErrorReportInput = {
  files: Array<Scalars['String']['input']>;
  message: Array<Scalars['JSONObject']['input']>;
  reportId: Scalars['String']['input'];
  title: Scalars['String']['input'];
  user?: InputMaybe<SendErrorReportUser>;
};

export type SendErrorReportResponse = {
  __typename?: 'SendErrorReportResponse';
  success: Scalars['Boolean']['output'];
};

export type SendErrorReportUser = {
  email: Scalars['String']['input'];
  tenant: Scalars['String']['input'];
  userId: Scalars['String']['input'];
  userType: UserType;
};

export type Session = Node & {
  __typename?: 'Session';
  _id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  rCategories?: Maybe<Array<Category>>;
  rEvaluations?: Maybe<Array<Evaluation>>;
};

export enum SessionOverrideType {
  ExtendTime = 'EXTEND_TIME',
  HelpRequest = 'HELP_REQUEST',
  HelpRequestResolved = 'HELP_REQUEST_RESOLVED',
  OpenEvaluation = 'OPEN_EVALUATION',
  SessionPause = 'SESSION_PAUSE',
  SessionResume = 'SESSION_RESUME'
}

export type SessionReport = Node & {
  __typename?: 'SessionReport';
  _id: Scalars['ID']['output'];
  accessCode?: Maybe<Scalars['String']['output']>;
  cookies?: Maybe<Array<CookieValue>>;
};

export type SignupParticipantInput = {
  company?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  externalId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type UserIdentifierInput = {
  type: UserIdentifierType;
  value: Scalars['String']['input'];
};

export enum UserIdentifierType {
  Email = 'EMAIL',
  Phone = 'PHONE'
}

export enum UserType {
  Admin = 'ADMIN',
  User = 'USER'
}

export type UserAddressFieldsFragment = { __typename?: 'Address', line1?: string | null, postal?: string | null, city?: string | null, region?: string | null, country?: string | null };

export type UserAnswerFieldsFragment = { __typename?: 'Answer', textValue?: string | null, numericValue?: number | null, booleanValue?: boolean | null, textlistValue?: Array<string> | null, booleanlistValue?: Array<boolean> | null, numericlistValue?: Array<number> | null, blocklistValue?: Array<any> | null };

export type UserCategoryFieldsFragment = { __typename?: 'Category', _id: string, name?: string | null };

export type UserCompanyFieldsFragment = { __typename?: 'Company', name?: string | null, _id: string, _createdAt: string, _updatedAt: string, _type: string, _rev: string };

export type CookieValueFieldsFragment = { __typename?: 'CookieValue', name: string, value: string, expires?: string | null, secure?: boolean | null, sameSite?: string | null, path?: string | null };

export type UserEvaluationFieldsFragment = { __typename?: 'Evaluation', _id: string, name?: string | null, description?: string | null, totalMaxTime?: number | null, categories?: Array<{ __typename?: 'SanityBaseRef', _ref: string }> | null, options?: { __typename?: 'EvaluationOptions', enableTimer?: boolean | null } | null, rQuestions?: Array<{ __typename?: 'Question', _id: string, name?: string | null, categories?: Array<{ __typename?: 'SanityBaseRef', _ref: string }> | null, rCategories?: Array<{ __typename?: 'Category', _id: string, name?: string | null }> | null, steps?: Array<{ __typename?: 'QuestionStep', type?: QuestionStepType | null, question?: Array<any> | null, answer?: { __typename?: 'Answer', textValue?: string | null, numericValue?: number | null, booleanValue?: boolean | null, textlistValue?: Array<string> | null, booleanlistValue?: Array<boolean> | null, numericlistValue?: Array<number> | null, blocklistValue?: Array<any> | null } | null }> | null, options?: { __typename?: 'QuestionOptions', maxTime?: number | null } | null }> | null };

export type UserLocationFieldsFragment = { __typename?: 'Location', _id: string, name?: string | null, address?: { __typename?: 'Address', line1?: string | null, postal?: string | null, city?: string | null, region?: string | null, country?: string | null } | null };

export type UserPageInfoFieldsFragment = { __typename?: 'PageInfo', totalCount?: number | null, pageSize?: number | null, hasPreviousPage?: boolean | null, hasNextPage?: boolean | null, startCursor?: string | null, endCursor?: string | null };

export type UserParticipantFieldsFragment = { __typename?: 'Participant', _id: string, name?: string | null, email?: string | null, phone?: string | null };

export type UserQuestionFieldsFragment = { __typename?: 'Question', _id: string, name?: string | null, categories?: Array<{ __typename?: 'SanityBaseRef', _ref: string }> | null, rCategories?: Array<{ __typename?: 'Category', _id: string, name?: string | null }> | null, steps?: Array<{ __typename?: 'QuestionStep', type?: QuestionStepType | null, question?: Array<any> | null, answer?: { __typename?: 'Answer', textValue?: string | null, numericValue?: number | null, booleanValue?: boolean | null, textlistValue?: Array<string> | null, booleanlistValue?: Array<boolean> | null, numericlistValue?: Array<number> | null, blocklistValue?: Array<any> | null } | null }> | null, options?: { __typename?: 'QuestionOptions', maxTime?: number | null } | null };

export type UserRealtimeTokenFieldsFragment = { __typename?: 'RealtimeToken', token: string, expires: number, issued: number, capability: string, clientId?: string | null };

type UserSanityDocumentFields_Company_Fragment = { __typename?: 'Company', _id: string, _createdAt: string, _updatedAt: string, _type: string, _rev: string };

type UserSanityDocumentFields_Organization_Fragment = { __typename?: 'Organization', _id: string, _createdAt: string, _updatedAt: string, _type: string, _rev: string };

type UserSanityDocumentFields_ScheduledSession_Fragment = { __typename?: 'ScheduledSession', _id: string, _createdAt: string, _updatedAt: string, _type: string, _rev: string };

type UserSanityDocumentFields_ScheduledSessionParticipantEntry_Fragment = { __typename?: 'ScheduledSessionParticipantEntry', _id: string, _createdAt: string, _updatedAt: string, _type: string, _rev: string };

export type UserSanityDocumentFieldsFragment = UserSanityDocumentFields_Company_Fragment | UserSanityDocumentFields_Organization_Fragment | UserSanityDocumentFields_ScheduledSession_Fragment | UserSanityDocumentFields_ScheduledSessionParticipantEntry_Fragment;

export type UserScheduledSessionFieldsFragment = { __typename?: 'ScheduledSession', _id: string, _rev: string, _type: string, _createdAt: string, _updatedAt: string, status?: ScheduledSessionStatus | null, datetime?: string | null, autoAdvance?: boolean | null, options?: { __typename?: 'ScheduledSessionOptions', allQuestionsInEvaluationShownByDefault?: boolean | null, enableAutoPauseOnHelpRequest?: boolean | null } | null, rSession?: { __typename?: 'Session', _id: string, name?: string | null, rCategories?: Array<{ __typename?: 'Category', _id: string, name?: string | null }> | null, rEvaluations?: Array<{ __typename?: 'Evaluation', _id: string, name?: string | null, description?: string | null, totalMaxTime?: number | null, categories?: Array<{ __typename?: 'SanityBaseRef', _ref: string }> | null, options?: { __typename?: 'EvaluationOptions', enableTimer?: boolean | null } | null, rQuestions?: Array<{ __typename?: 'Question', _id: string, name?: string | null, categories?: Array<{ __typename?: 'SanityBaseRef', _ref: string }> | null, rCategories?: Array<{ __typename?: 'Category', _id: string, name?: string | null }> | null, steps?: Array<{ __typename?: 'QuestionStep', type?: QuestionStepType | null, question?: Array<any> | null, answer?: { __typename?: 'Answer', textValue?: string | null, numericValue?: number | null, booleanValue?: boolean | null, textlistValue?: Array<string> | null, booleanlistValue?: Array<boolean> | null, numericlistValue?: Array<number> | null, blocklistValue?: Array<any> | null } | null }> | null, options?: { __typename?: 'QuestionOptions', maxTime?: number | null } | null }> | null }> | null } | null, rLocation?: { __typename?: 'Location', _id: string, name?: string | null, address?: { __typename?: 'Address', line1?: string | null, postal?: string | null, city?: string | null, region?: string | null, country?: string | null } | null } | null };

export type UserScheduledSessionParticipantEntryFieldsFragment = { __typename?: 'ScheduledSessionParticipantEntry', _id: string, _rev: string, _type: string, _updatedAt: string, _createdAt: string, ready?: boolean | null, sessionStart?: string | null, reassignedEvaluationId?: string | null, timeLeft?: number | null, expectedEndTime?: string | null, currentState?: { __typename?: 'ScheduledSessionParticipantEntryCurrentState', status?: ParticipantSessionStatus | null, stepIndex?: number | null, lastUpdated?: string | null, isReassigned?: boolean | null, isCurrentEvaluationEnded?: boolean | null, finishedEvaluationIds?: Array<string> | null, totalEvaluationsCount?: number | null, progressPercentage?: number | null, correctedEvaluationIds?: Array<string> | null, reassignedWithUnsubmittedCorrectionsEvaluationIds?: Array<string> | null, evaluation?: { __typename?: 'SanityBaseRef', _ref: string } | null, question?: { __typename?: 'SanityBaseRef', _ref: string } | null, rEvaluation?: { __typename?: 'Evaluation', _id: string, name?: string | null, description?: string | null, totalMaxTime?: number | null, categories?: Array<{ __typename?: 'SanityBaseRef', _ref: string }> | null, options?: { __typename?: 'EvaluationOptions', enableTimer?: boolean | null } | null, rQuestions?: Array<{ __typename?: 'Question', _id: string, name?: string | null, categories?: Array<{ __typename?: 'SanityBaseRef', _ref: string }> | null, rCategories?: Array<{ __typename?: 'Category', _id: string, name?: string | null }> | null, steps?: Array<{ __typename?: 'QuestionStep', type?: QuestionStepType | null, question?: Array<any> | null, answer?: { __typename?: 'Answer', textValue?: string | null, numericValue?: number | null, booleanValue?: boolean | null, textlistValue?: Array<string> | null, booleanlistValue?: Array<boolean> | null, numericlistValue?: Array<number> | null, blocklistValue?: Array<any> | null } | null }> | null, options?: { __typename?: 'QuestionOptions', maxTime?: number | null } | null }> | null } | null, latestProgress?: { __typename?: 'ScheduledSessionParticipantEntryProgress', type?: string | null, timestamp?: string | null, sectionStart?: string | null, sectionEnd?: string | null } | null } | null, participant?: { __typename?: 'SanityBaseRef', _ref: string } | null, sessionOrder?: Array<{ __typename?: 'SanityBaseRef', _ref: string }> | null, sessionAnswers?: Array<{ __typename?: 'ScheduledSessionParticipantEntryAnswer', comment?: string | null, evaluation?: { __typename?: 'SanityBaseRef', _ref: string } | null, question?: { __typename?: 'SanityBaseRef', _ref: string } | null, answers?: Array<{ __typename?: 'Answer', textValue?: string | null, numericValue?: number | null, booleanValue?: boolean | null, textlistValue?: Array<string> | null, booleanlistValue?: Array<boolean> | null, numericlistValue?: Array<number> | null, blocklistValue?: Array<any> | null }> | null }> | null, sessionProgress?: Array<{ __typename?: 'ScheduledSessionParticipantEntryProgress', type?: string | null, timestamp?: string | null, sectionStart?: string | null, sectionEnd?: string | null, evaluation?: { __typename?: 'SanityBaseRef', _ref: string } | null, question?: { __typename?: 'SanityBaseRef', _ref: string } | null }> | null, sessionOverrides?: Array<{ __typename?: 'ScheduledSessionParticipantEntryOverride', datetime?: string | null, overrideType?: SessionOverrideType | null, evaluation?: { __typename?: 'SanityBaseRef', _ref: string } | null, question?: { __typename?: 'SanityBaseRef', _ref: string } | null, value?: { __typename?: 'ScheduledSessionParticipantEntryOverrideValue', numericValue?: number | null, textValue?: string | null } | null }> | null };

export type UserScheduledSessionParticipantEntryOverrideFieldsFragment = { __typename?: 'ScheduledSessionParticipantEntryOverride', datetime?: string | null, overrideType?: SessionOverrideType | null, evaluation?: { __typename?: 'SanityBaseRef', _ref: string } | null, question?: { __typename?: 'SanityBaseRef', _ref: string } | null, value?: { __typename?: 'ScheduledSessionParticipantEntryOverrideValue', numericValue?: number | null, textValue?: string | null } | null };

export type UserSessionFieldsFragment = { __typename?: 'Session', _id: string, name?: string | null, rCategories?: Array<{ __typename?: 'Category', _id: string, name?: string | null }> | null, rEvaluations?: Array<{ __typename?: 'Evaluation', _id: string, name?: string | null, description?: string | null, totalMaxTime?: number | null, categories?: Array<{ __typename?: 'SanityBaseRef', _ref: string }> | null, options?: { __typename?: 'EvaluationOptions', enableTimer?: boolean | null } | null, rQuestions?: Array<{ __typename?: 'Question', _id: string, name?: string | null, categories?: Array<{ __typename?: 'SanityBaseRef', _ref: string }> | null, rCategories?: Array<{ __typename?: 'Category', _id: string, name?: string | null }> | null, steps?: Array<{ __typename?: 'QuestionStep', type?: QuestionStepType | null, question?: Array<any> | null, answer?: { __typename?: 'Answer', textValue?: string | null, numericValue?: number | null, booleanValue?: boolean | null, textlistValue?: Array<string> | null, booleanlistValue?: Array<boolean> | null, numericlistValue?: Array<number> | null, blocklistValue?: Array<any> | null } | null }> | null, options?: { __typename?: 'QuestionOptions', maxTime?: number | null } | null }> | null }> | null };

export type AnswerEvaluationQuestionStepMutationVariables = Exact<{
  evaluation: Scalars['ID']['input'];
  question: Scalars['ID']['input'];
  stepIndex: Scalars['Int']['input'];
  answer: AnswerInput;
}>;


export type AnswerEvaluationQuestionStepMutation = { __typename?: 'Mutation', answerEvaluationQuestionStep?: { __typename?: 'ScheduledSessionParticipantEntry', _id: string, _rev: string, _type: string, _updatedAt: string, _createdAt: string, ready?: boolean | null, sessionStart?: string | null, reassignedEvaluationId?: string | null, timeLeft?: number | null, expectedEndTime?: string | null, currentState?: { __typename?: 'ScheduledSessionParticipantEntryCurrentState', status?: ParticipantSessionStatus | null, stepIndex?: number | null, lastUpdated?: string | null, isReassigned?: boolean | null, isCurrentEvaluationEnded?: boolean | null, finishedEvaluationIds?: Array<string> | null, totalEvaluationsCount?: number | null, progressPercentage?: number | null, correctedEvaluationIds?: Array<string> | null, reassignedWithUnsubmittedCorrectionsEvaluationIds?: Array<string> | null, evaluation?: { __typename?: 'SanityBaseRef', _ref: string } | null, question?: { __typename?: 'SanityBaseRef', _ref: string } | null, rEvaluation?: { __typename?: 'Evaluation', _id: string, name?: string | null, description?: string | null, totalMaxTime?: number | null, categories?: Array<{ __typename?: 'SanityBaseRef', _ref: string }> | null, options?: { __typename?: 'EvaluationOptions', enableTimer?: boolean | null } | null, rQuestions?: Array<{ __typename?: 'Question', _id: string, name?: string | null, categories?: Array<{ __typename?: 'SanityBaseRef', _ref: string }> | null, rCategories?: Array<{ __typename?: 'Category', _id: string, name?: string | null }> | null, steps?: Array<{ __typename?: 'QuestionStep', type?: QuestionStepType | null, question?: Array<any> | null, answer?: { __typename?: 'Answer', textValue?: string | null, numericValue?: number | null, booleanValue?: boolean | null, textlistValue?: Array<string> | null, booleanlistValue?: Array<boolean> | null, numericlistValue?: Array<number> | null, blocklistValue?: Array<any> | null } | null }> | null, options?: { __typename?: 'QuestionOptions', maxTime?: number | null } | null }> | null } | null, latestProgress?: { __typename?: 'ScheduledSessionParticipantEntryProgress', type?: string | null, timestamp?: string | null, sectionStart?: string | null, sectionEnd?: string | null } | null } | null, participant?: { __typename?: 'SanityBaseRef', _ref: string } | null, sessionOrder?: Array<{ __typename?: 'SanityBaseRef', _ref: string }> | null, sessionAnswers?: Array<{ __typename?: 'ScheduledSessionParticipantEntryAnswer', comment?: string | null, evaluation?: { __typename?: 'SanityBaseRef', _ref: string } | null, question?: { __typename?: 'SanityBaseRef', _ref: string } | null, answers?: Array<{ __typename?: 'Answer', textValue?: string | null, numericValue?: number | null, booleanValue?: boolean | null, textlistValue?: Array<string> | null, booleanlistValue?: Array<boolean> | null, numericlistValue?: Array<number> | null, blocklistValue?: Array<any> | null }> | null }> | null, sessionProgress?: Array<{ __typename?: 'ScheduledSessionParticipantEntryProgress', type?: string | null, timestamp?: string | null, sectionStart?: string | null, sectionEnd?: string | null, evaluation?: { __typename?: 'SanityBaseRef', _ref: string } | null, question?: { __typename?: 'SanityBaseRef', _ref: string } | null }> | null, sessionOverrides?: Array<{ __typename?: 'ScheduledSessionParticipantEntryOverride', datetime?: string | null, overrideType?: SessionOverrideType | null, evaluation?: { __typename?: 'SanityBaseRef', _ref: string } | null, question?: { __typename?: 'SanityBaseRef', _ref: string } | null, value?: { __typename?: 'ScheduledSessionParticipantEntryOverrideValue', numericValue?: number | null, textValue?: string | null } | null }> | null } | null };

export type CompleteAndCloseQuestionOrEvaluationMutationVariables = Exact<{
  evaluation: Scalars['ID']['input'];
  question?: InputMaybe<Scalars['ID']['input']>;
}>;


export type CompleteAndCloseQuestionOrEvaluationMutation = { __typename?: 'Mutation', completeAndCloseQuestionOrEvaluation?: { __typename?: 'ScheduledSessionParticipantEntry', _id: string, _rev: string, _type: string, _updatedAt: string, _createdAt: string, ready?: boolean | null, sessionStart?: string | null, reassignedEvaluationId?: string | null, timeLeft?: number | null, expectedEndTime?: string | null, currentState?: { __typename?: 'ScheduledSessionParticipantEntryCurrentState', status?: ParticipantSessionStatus | null, stepIndex?: number | null, lastUpdated?: string | null, isReassigned?: boolean | null, isCurrentEvaluationEnded?: boolean | null, finishedEvaluationIds?: Array<string> | null, totalEvaluationsCount?: number | null, progressPercentage?: number | null, correctedEvaluationIds?: Array<string> | null, reassignedWithUnsubmittedCorrectionsEvaluationIds?: Array<string> | null, evaluation?: { __typename?: 'SanityBaseRef', _ref: string } | null, question?: { __typename?: 'SanityBaseRef', _ref: string } | null, rEvaluation?: { __typename?: 'Evaluation', _id: string, name?: string | null, description?: string | null, totalMaxTime?: number | null, categories?: Array<{ __typename?: 'SanityBaseRef', _ref: string }> | null, options?: { __typename?: 'EvaluationOptions', enableTimer?: boolean | null } | null, rQuestions?: Array<{ __typename?: 'Question', _id: string, name?: string | null, categories?: Array<{ __typename?: 'SanityBaseRef', _ref: string }> | null, rCategories?: Array<{ __typename?: 'Category', _id: string, name?: string | null }> | null, steps?: Array<{ __typename?: 'QuestionStep', type?: QuestionStepType | null, question?: Array<any> | null, answer?: { __typename?: 'Answer', textValue?: string | null, numericValue?: number | null, booleanValue?: boolean | null, textlistValue?: Array<string> | null, booleanlistValue?: Array<boolean> | null, numericlistValue?: Array<number> | null, blocklistValue?: Array<any> | null } | null }> | null, options?: { __typename?: 'QuestionOptions', maxTime?: number | null } | null }> | null } | null, latestProgress?: { __typename?: 'ScheduledSessionParticipantEntryProgress', type?: string | null, timestamp?: string | null, sectionStart?: string | null, sectionEnd?: string | null } | null } | null, participant?: { __typename?: 'SanityBaseRef', _ref: string } | null, sessionOrder?: Array<{ __typename?: 'SanityBaseRef', _ref: string }> | null, sessionAnswers?: Array<{ __typename?: 'ScheduledSessionParticipantEntryAnswer', comment?: string | null, evaluation?: { __typename?: 'SanityBaseRef', _ref: string } | null, question?: { __typename?: 'SanityBaseRef', _ref: string } | null, answers?: Array<{ __typename?: 'Answer', textValue?: string | null, numericValue?: number | null, booleanValue?: boolean | null, textlistValue?: Array<string> | null, booleanlistValue?: Array<boolean> | null, numericlistValue?: Array<number> | null, blocklistValue?: Array<any> | null }> | null }> | null, sessionProgress?: Array<{ __typename?: 'ScheduledSessionParticipantEntryProgress', type?: string | null, timestamp?: string | null, sectionStart?: string | null, sectionEnd?: string | null, evaluation?: { __typename?: 'SanityBaseRef', _ref: string } | null, question?: { __typename?: 'SanityBaseRef', _ref: string } | null }> | null, sessionOverrides?: Array<{ __typename?: 'ScheduledSessionParticipantEntryOverride', datetime?: string | null, overrideType?: SessionOverrideType | null, evaluation?: { __typename?: 'SanityBaseRef', _ref: string } | null, question?: { __typename?: 'SanityBaseRef', _ref: string } | null, value?: { __typename?: 'ScheduledSessionParticipantEntryOverrideValue', numericValue?: number | null, textValue?: string | null } | null }> | null } | null };

export type CompleteOtpLoginMutationVariables = Exact<{
  tenant: Scalars['String']['input'];
  userIdentifier: UserIdentifierInput;
  loginCode: Scalars['String']['input'];
  otp: Scalars['String']['input'];
}>;


export type CompleteOtpLoginMutation = { __typename?: 'Mutation', completeOtpLogin?: { __typename?: 'CompleteOtpLoginResponse', success: boolean, cookies?: Array<{ __typename?: 'CookieValue', name: string, value: string, expires?: string | null, secure?: boolean | null, sameSite?: string | null, path?: string | null }> | null } | null };

export type CompleteSessionReportLoginMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  accessCode: Scalars['String']['input'];
}>;


export type CompleteSessionReportLoginMutation = { __typename?: 'Mutation', completeSessionReportLogin?: { __typename?: 'SessionReport', _id: string, accessCode?: string | null, cookies?: Array<{ __typename?: 'CookieValue', name: string, value: string, expires?: string | null, secure?: boolean | null, sameSite?: string | null, path?: string | null }> | null } | null };

export type ContinueSessionMutationVariables = Exact<{
  evaluation?: InputMaybe<Scalars['ID']['input']>;
}>;


export type ContinueSessionMutation = { __typename?: 'Mutation', continueSession?: { __typename?: 'ScheduledSessionParticipantEntry', _id: string, _rev: string, _type: string, _updatedAt: string, _createdAt: string, ready?: boolean | null, sessionStart?: string | null, reassignedEvaluationId?: string | null, timeLeft?: number | null, expectedEndTime?: string | null, currentState?: { __typename?: 'ScheduledSessionParticipantEntryCurrentState', status?: ParticipantSessionStatus | null, stepIndex?: number | null, lastUpdated?: string | null, isReassigned?: boolean | null, isCurrentEvaluationEnded?: boolean | null, finishedEvaluationIds?: Array<string> | null, totalEvaluationsCount?: number | null, progressPercentage?: number | null, correctedEvaluationIds?: Array<string> | null, reassignedWithUnsubmittedCorrectionsEvaluationIds?: Array<string> | null, evaluation?: { __typename?: 'SanityBaseRef', _ref: string } | null, question?: { __typename?: 'SanityBaseRef', _ref: string } | null, rEvaluation?: { __typename?: 'Evaluation', _id: string, name?: string | null, description?: string | null, totalMaxTime?: number | null, categories?: Array<{ __typename?: 'SanityBaseRef', _ref: string }> | null, options?: { __typename?: 'EvaluationOptions', enableTimer?: boolean | null } | null, rQuestions?: Array<{ __typename?: 'Question', _id: string, name?: string | null, categories?: Array<{ __typename?: 'SanityBaseRef', _ref: string }> | null, rCategories?: Array<{ __typename?: 'Category', _id: string, name?: string | null }> | null, steps?: Array<{ __typename?: 'QuestionStep', type?: QuestionStepType | null, question?: Array<any> | null, answer?: { __typename?: 'Answer', textValue?: string | null, numericValue?: number | null, booleanValue?: boolean | null, textlistValue?: Array<string> | null, booleanlistValue?: Array<boolean> | null, numericlistValue?: Array<number> | null, blocklistValue?: Array<any> | null } | null }> | null, options?: { __typename?: 'QuestionOptions', maxTime?: number | null } | null }> | null } | null, latestProgress?: { __typename?: 'ScheduledSessionParticipantEntryProgress', type?: string | null, timestamp?: string | null, sectionStart?: string | null, sectionEnd?: string | null } | null } | null, participant?: { __typename?: 'SanityBaseRef', _ref: string } | null, sessionOrder?: Array<{ __typename?: 'SanityBaseRef', _ref: string }> | null, sessionAnswers?: Array<{ __typename?: 'ScheduledSessionParticipantEntryAnswer', comment?: string | null, evaluation?: { __typename?: 'SanityBaseRef', _ref: string } | null, question?: { __typename?: 'SanityBaseRef', _ref: string } | null, answers?: Array<{ __typename?: 'Answer', textValue?: string | null, numericValue?: number | null, booleanValue?: boolean | null, textlistValue?: Array<string> | null, booleanlistValue?: Array<boolean> | null, numericlistValue?: Array<number> | null, blocklistValue?: Array<any> | null }> | null }> | null, sessionProgress?: Array<{ __typename?: 'ScheduledSessionParticipantEntryProgress', type?: string | null, timestamp?: string | null, sectionStart?: string | null, sectionEnd?: string | null, evaluation?: { __typename?: 'SanityBaseRef', _ref: string } | null, question?: { __typename?: 'SanityBaseRef', _ref: string } | null }> | null, sessionOverrides?: Array<{ __typename?: 'ScheduledSessionParticipantEntryOverride', datetime?: string | null, overrideType?: SessionOverrideType | null, evaluation?: { __typename?: 'SanityBaseRef', _ref: string } | null, question?: { __typename?: 'SanityBaseRef', _ref: string } | null, value?: { __typename?: 'ScheduledSessionParticipantEntryOverrideValue', numericValue?: number | null, textValue?: string | null } | null }> | null } | null };

export type GetRealtimeTokenMutationVariables = Exact<{ [key: string]: never; }>;


export type GetRealtimeTokenMutation = { __typename?: 'Mutation', getRealtimeToken?: { __typename?: 'RealtimeToken', token: string, expires: number, issued: number, capability: string, clientId?: string | null } | null };

export type LogoutParticipantMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutParticipantMutation = { __typename?: 'Mutation', logout: { __typename?: 'LogoutResponse', success: boolean } };

export type ReadyScheduledSessionMutationVariables = Exact<{ [key: string]: never; }>;


export type ReadyScheduledSessionMutation = { __typename?: 'Mutation', readyScheduledSession?: { __typename?: 'ScheduledSessionParticipantEntry', _id: string, _rev: string, _type: string, _updatedAt: string, _createdAt: string, ready?: boolean | null, sessionStart?: string | null, reassignedEvaluationId?: string | null, timeLeft?: number | null, expectedEndTime?: string | null, currentState?: { __typename?: 'ScheduledSessionParticipantEntryCurrentState', status?: ParticipantSessionStatus | null, stepIndex?: number | null, lastUpdated?: string | null, isReassigned?: boolean | null, isCurrentEvaluationEnded?: boolean | null, finishedEvaluationIds?: Array<string> | null, totalEvaluationsCount?: number | null, progressPercentage?: number | null, correctedEvaluationIds?: Array<string> | null, reassignedWithUnsubmittedCorrectionsEvaluationIds?: Array<string> | null, evaluation?: { __typename?: 'SanityBaseRef', _ref: string } | null, question?: { __typename?: 'SanityBaseRef', _ref: string } | null, rEvaluation?: { __typename?: 'Evaluation', _id: string, name?: string | null, description?: string | null, totalMaxTime?: number | null, categories?: Array<{ __typename?: 'SanityBaseRef', _ref: string }> | null, options?: { __typename?: 'EvaluationOptions', enableTimer?: boolean | null } | null, rQuestions?: Array<{ __typename?: 'Question', _id: string, name?: string | null, categories?: Array<{ __typename?: 'SanityBaseRef', _ref: string }> | null, rCategories?: Array<{ __typename?: 'Category', _id: string, name?: string | null }> | null, steps?: Array<{ __typename?: 'QuestionStep', type?: QuestionStepType | null, question?: Array<any> | null, answer?: { __typename?: 'Answer', textValue?: string | null, numericValue?: number | null, booleanValue?: boolean | null, textlistValue?: Array<string> | null, booleanlistValue?: Array<boolean> | null, numericlistValue?: Array<number> | null, blocklistValue?: Array<any> | null } | null }> | null, options?: { __typename?: 'QuestionOptions', maxTime?: number | null } | null }> | null } | null, latestProgress?: { __typename?: 'ScheduledSessionParticipantEntryProgress', type?: string | null, timestamp?: string | null, sectionStart?: string | null, sectionEnd?: string | null } | null } | null, participant?: { __typename?: 'SanityBaseRef', _ref: string } | null, sessionOrder?: Array<{ __typename?: 'SanityBaseRef', _ref: string }> | null, sessionAnswers?: Array<{ __typename?: 'ScheduledSessionParticipantEntryAnswer', comment?: string | null, evaluation?: { __typename?: 'SanityBaseRef', _ref: string } | null, question?: { __typename?: 'SanityBaseRef', _ref: string } | null, answers?: Array<{ __typename?: 'Answer', textValue?: string | null, numericValue?: number | null, booleanValue?: boolean | null, textlistValue?: Array<string> | null, booleanlistValue?: Array<boolean> | null, numericlistValue?: Array<number> | null, blocklistValue?: Array<any> | null }> | null }> | null, sessionProgress?: Array<{ __typename?: 'ScheduledSessionParticipantEntryProgress', type?: string | null, timestamp?: string | null, sectionStart?: string | null, sectionEnd?: string | null, evaluation?: { __typename?: 'SanityBaseRef', _ref: string } | null, question?: { __typename?: 'SanityBaseRef', _ref: string } | null }> | null, sessionOverrides?: Array<{ __typename?: 'ScheduledSessionParticipantEntryOverride', datetime?: string | null, overrideType?: SessionOverrideType | null, evaluation?: { __typename?: 'SanityBaseRef', _ref: string } | null, question?: { __typename?: 'SanityBaseRef', _ref: string } | null, value?: { __typename?: 'ScheduledSessionParticipantEntryOverrideValue', numericValue?: number | null, textValue?: string | null } | null }> | null } | null };

export type RequestCloudinaryUploadSignatureMutationVariables = Exact<{ [key: string]: never; }>;


export type RequestCloudinaryUploadSignatureMutation = { __typename?: 'Mutation', requestCloudinaryUploadSignature?: { __typename?: 'CloudinaryUploadSignature', signature: string, timestamp: number, public_id: string } | null };

export type RequestHelpMutationVariables = Exact<{
  evaluation?: InputMaybe<Scalars['ID']['input']>;
  question?: InputMaybe<Scalars['ID']['input']>;
}>;


export type RequestHelpMutation = { __typename?: 'Mutation', requestHelp?: { __typename?: 'ScheduledSessionParticipantEntry', _id: string, _rev: string, _type: string, _updatedAt: string, _createdAt: string, ready?: boolean | null, sessionStart?: string | null, reassignedEvaluationId?: string | null, timeLeft?: number | null, expectedEndTime?: string | null, currentState?: { __typename?: 'ScheduledSessionParticipantEntryCurrentState', status?: ParticipantSessionStatus | null, stepIndex?: number | null, lastUpdated?: string | null, isReassigned?: boolean | null, isCurrentEvaluationEnded?: boolean | null, finishedEvaluationIds?: Array<string> | null, totalEvaluationsCount?: number | null, progressPercentage?: number | null, correctedEvaluationIds?: Array<string> | null, reassignedWithUnsubmittedCorrectionsEvaluationIds?: Array<string> | null, evaluation?: { __typename?: 'SanityBaseRef', _ref: string } | null, question?: { __typename?: 'SanityBaseRef', _ref: string } | null, rEvaluation?: { __typename?: 'Evaluation', _id: string, name?: string | null, description?: string | null, totalMaxTime?: number | null, categories?: Array<{ __typename?: 'SanityBaseRef', _ref: string }> | null, options?: { __typename?: 'EvaluationOptions', enableTimer?: boolean | null } | null, rQuestions?: Array<{ __typename?: 'Question', _id: string, name?: string | null, categories?: Array<{ __typename?: 'SanityBaseRef', _ref: string }> | null, rCategories?: Array<{ __typename?: 'Category', _id: string, name?: string | null }> | null, steps?: Array<{ __typename?: 'QuestionStep', type?: QuestionStepType | null, question?: Array<any> | null, answer?: { __typename?: 'Answer', textValue?: string | null, numericValue?: number | null, booleanValue?: boolean | null, textlistValue?: Array<string> | null, booleanlistValue?: Array<boolean> | null, numericlistValue?: Array<number> | null, blocklistValue?: Array<any> | null } | null }> | null, options?: { __typename?: 'QuestionOptions', maxTime?: number | null } | null }> | null } | null, latestProgress?: { __typename?: 'ScheduledSessionParticipantEntryProgress', type?: string | null, timestamp?: string | null, sectionStart?: string | null, sectionEnd?: string | null } | null } | null, participant?: { __typename?: 'SanityBaseRef', _ref: string } | null, sessionOrder?: Array<{ __typename?: 'SanityBaseRef', _ref: string }> | null, sessionAnswers?: Array<{ __typename?: 'ScheduledSessionParticipantEntryAnswer', comment?: string | null, evaluation?: { __typename?: 'SanityBaseRef', _ref: string } | null, question?: { __typename?: 'SanityBaseRef', _ref: string } | null, answers?: Array<{ __typename?: 'Answer', textValue?: string | null, numericValue?: number | null, booleanValue?: boolean | null, textlistValue?: Array<string> | null, booleanlistValue?: Array<boolean> | null, numericlistValue?: Array<number> | null, blocklistValue?: Array<any> | null }> | null }> | null, sessionProgress?: Array<{ __typename?: 'ScheduledSessionParticipantEntryProgress', type?: string | null, timestamp?: string | null, sectionStart?: string | null, sectionEnd?: string | null, evaluation?: { __typename?: 'SanityBaseRef', _ref: string } | null, question?: { __typename?: 'SanityBaseRef', _ref: string } | null }> | null, sessionOverrides?: Array<{ __typename?: 'ScheduledSessionParticipantEntryOverride', datetime?: string | null, overrideType?: SessionOverrideType | null, evaluation?: { __typename?: 'SanityBaseRef', _ref: string } | null, question?: { __typename?: 'SanityBaseRef', _ref: string } | null, value?: { __typename?: 'ScheduledSessionParticipantEntryOverrideValue', numericValue?: number | null, textValue?: string | null } | null }> | null } | null };

export type RequestLoginMutationVariables = Exact<{
  tenant: Scalars['String']['input'];
  userIdentifier: UserIdentifierInput;
  loginCode: Scalars['String']['input'];
}>;


export type RequestLoginMutation = { __typename?: 'Mutation', requestLogin?: boolean | null };

export type SendErrorReportMutationVariables = Exact<{
  input: SendErrorReportInput;
}>;


export type SendErrorReportMutation = { __typename?: 'Mutation', sendErrorReport: { __typename?: 'SendErrorReportResponse', success: boolean } };

export type SignupForScheduledSessionMutationVariables = Exact<{
  tenant: Scalars['String']['input'];
  loginCode: Scalars['String']['input'];
  userIdentifier: UserIdentifierInput;
  participant: SignupParticipantInput;
}>;


export type SignupForScheduledSessionMutation = { __typename?: 'Mutation', signupForScheduledSession?: boolean | null };

export type AllCompaniesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  tenant: Scalars['String']['input'];
}>;


export type AllCompaniesQuery = { __typename?: 'Query', allCompanies: { __typename?: 'CompanyConnection', pageInfo: { __typename?: 'PageInfo', totalCount?: number | null, pageSize?: number | null, hasPreviousPage?: boolean | null, hasNextPage?: boolean | null, startCursor?: string | null, endCursor?: string | null }, edges?: Array<{ __typename?: 'CompanyEdge', cursor: string, node: { __typename?: 'Company', name?: string | null, _id: string, _createdAt: string, _updatedAt: string, _type: string, _rev: string } }> | null } };

export type MyScheduledSessionParticipantEntryQueryVariables = Exact<{ [key: string]: never; }>;


export type MyScheduledSessionParticipantEntryQuery = { __typename?: 'Query', myScheduledSessionParticipantEntry?: { __typename?: 'ScheduledSessionParticipantEntry', _id: string, _rev: string, _type: string, _updatedAt: string, _createdAt: string, ready?: boolean | null, sessionStart?: string | null, reassignedEvaluationId?: string | null, timeLeft?: number | null, expectedEndTime?: string | null, currentState?: { __typename?: 'ScheduledSessionParticipantEntryCurrentState', status?: ParticipantSessionStatus | null, stepIndex?: number | null, lastUpdated?: string | null, isReassigned?: boolean | null, isCurrentEvaluationEnded?: boolean | null, finishedEvaluationIds?: Array<string> | null, totalEvaluationsCount?: number | null, progressPercentage?: number | null, correctedEvaluationIds?: Array<string> | null, reassignedWithUnsubmittedCorrectionsEvaluationIds?: Array<string> | null, evaluation?: { __typename?: 'SanityBaseRef', _ref: string } | null, question?: { __typename?: 'SanityBaseRef', _ref: string } | null, rEvaluation?: { __typename?: 'Evaluation', _id: string, name?: string | null, description?: string | null, totalMaxTime?: number | null, categories?: Array<{ __typename?: 'SanityBaseRef', _ref: string }> | null, options?: { __typename?: 'EvaluationOptions', enableTimer?: boolean | null } | null, rQuestions?: Array<{ __typename?: 'Question', _id: string, name?: string | null, categories?: Array<{ __typename?: 'SanityBaseRef', _ref: string }> | null, rCategories?: Array<{ __typename?: 'Category', _id: string, name?: string | null }> | null, steps?: Array<{ __typename?: 'QuestionStep', type?: QuestionStepType | null, question?: Array<any> | null, answer?: { __typename?: 'Answer', textValue?: string | null, numericValue?: number | null, booleanValue?: boolean | null, textlistValue?: Array<string> | null, booleanlistValue?: Array<boolean> | null, numericlistValue?: Array<number> | null, blocklistValue?: Array<any> | null } | null }> | null, options?: { __typename?: 'QuestionOptions', maxTime?: number | null } | null }> | null } | null, latestProgress?: { __typename?: 'ScheduledSessionParticipantEntryProgress', type?: string | null, timestamp?: string | null, sectionStart?: string | null, sectionEnd?: string | null } | null } | null, participant?: { __typename?: 'SanityBaseRef', _ref: string } | null, sessionOrder?: Array<{ __typename?: 'SanityBaseRef', _ref: string }> | null, sessionAnswers?: Array<{ __typename?: 'ScheduledSessionParticipantEntryAnswer', comment?: string | null, evaluation?: { __typename?: 'SanityBaseRef', _ref: string } | null, question?: { __typename?: 'SanityBaseRef', _ref: string } | null, answers?: Array<{ __typename?: 'Answer', textValue?: string | null, numericValue?: number | null, booleanValue?: boolean | null, textlistValue?: Array<string> | null, booleanlistValue?: Array<boolean> | null, numericlistValue?: Array<number> | null, blocklistValue?: Array<any> | null }> | null }> | null, sessionProgress?: Array<{ __typename?: 'ScheduledSessionParticipantEntryProgress', type?: string | null, timestamp?: string | null, sectionStart?: string | null, sectionEnd?: string | null, evaluation?: { __typename?: 'SanityBaseRef', _ref: string } | null, question?: { __typename?: 'SanityBaseRef', _ref: string } | null }> | null, sessionOverrides?: Array<{ __typename?: 'ScheduledSessionParticipantEntryOverride', datetime?: string | null, overrideType?: SessionOverrideType | null, evaluation?: { __typename?: 'SanityBaseRef', _ref: string } | null, question?: { __typename?: 'SanityBaseRef', _ref: string } | null, value?: { __typename?: 'ScheduledSessionParticipantEntryOverrideValue', numericValue?: number | null, textValue?: string | null } | null }> | null } | null };

export type MyScheduledSessionQueryVariables = Exact<{ [key: string]: never; }>;


export type MyScheduledSessionQuery = { __typename?: 'Query', myScheduledSession?: { __typename?: 'ScheduledSession', _id: string, _rev: string, _type: string, _createdAt: string, _updatedAt: string, status?: ScheduledSessionStatus | null, datetime?: string | null, autoAdvance?: boolean | null, options?: { __typename?: 'ScheduledSessionOptions', allQuestionsInEvaluationShownByDefault?: boolean | null, enableAutoPauseOnHelpRequest?: boolean | null } | null, rSession?: { __typename?: 'Session', _id: string, name?: string | null, rCategories?: Array<{ __typename?: 'Category', _id: string, name?: string | null }> | null, rEvaluations?: Array<{ __typename?: 'Evaluation', _id: string, name?: string | null, description?: string | null, totalMaxTime?: number | null, categories?: Array<{ __typename?: 'SanityBaseRef', _ref: string }> | null, options?: { __typename?: 'EvaluationOptions', enableTimer?: boolean | null } | null, rQuestions?: Array<{ __typename?: 'Question', _id: string, name?: string | null, categories?: Array<{ __typename?: 'SanityBaseRef', _ref: string }> | null, rCategories?: Array<{ __typename?: 'Category', _id: string, name?: string | null }> | null, steps?: Array<{ __typename?: 'QuestionStep', type?: QuestionStepType | null, question?: Array<any> | null, answer?: { __typename?: 'Answer', textValue?: string | null, numericValue?: number | null, booleanValue?: boolean | null, textlistValue?: Array<string> | null, booleanlistValue?: Array<boolean> | null, numericlistValue?: Array<number> | null, blocklistValue?: Array<any> | null } | null }> | null, options?: { __typename?: 'QuestionOptions', maxTime?: number | null } | null }> | null }> | null } | null, rLocation?: { __typename?: 'Location', _id: string, name?: string | null, address?: { __typename?: 'Address', line1?: string | null, postal?: string | null, city?: string | null, region?: string | null, country?: string | null } | null } | null } | null };

export type OrganizationTenantExistsQueryVariables = Exact<{
  tenant: Scalars['String']['input'];
}>;


export type OrganizationTenantExistsQuery = { __typename?: 'Query', organizationTenantExists?: boolean | null };



export type ResolverTypeWrapper<T> = Promise<T> | T;


export type ResolverWithResolve<TResult, TParent, TContext, TArgs> = {
  resolve: ResolverFn<TResult, TParent, TContext, TArgs>;
};
export type Resolver<TResult, TParent = {}, TContext = {}, TArgs = {}> = ResolverFn<TResult, TParent, TContext, TArgs> | ResolverWithResolve<TResult, TParent, TContext, TArgs>;

export type ResolverFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => Promise<TResult> | TResult;

export type SubscriptionSubscribeFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => AsyncIterable<TResult> | Promise<AsyncIterable<TResult>>;

export type SubscriptionResolveFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

export interface SubscriptionSubscriberObject<TResult, TKey extends string, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<{ [key in TKey]: TResult }, TParent, TContext, TArgs>;
  resolve?: SubscriptionResolveFn<TResult, { [key in TKey]: TResult }, TContext, TArgs>;
}

export interface SubscriptionResolverObject<TResult, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<any, TParent, TContext, TArgs>;
  resolve: SubscriptionResolveFn<TResult, any, TContext, TArgs>;
}

export type SubscriptionObject<TResult, TKey extends string, TParent, TContext, TArgs> =
  | SubscriptionSubscriberObject<TResult, TKey, TParent, TContext, TArgs>
  | SubscriptionResolverObject<TResult, TParent, TContext, TArgs>;

export type SubscriptionResolver<TResult, TKey extends string, TParent = {}, TContext = {}, TArgs = {}> =
  | ((...args: any[]) => SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>)
  | SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>;

export type TypeResolveFn<TTypes, TParent = {}, TContext = {}> = (
  parent: TParent,
  context: TContext,
  info: GraphQLResolveInfo
) => Maybe<TTypes> | Promise<Maybe<TTypes>>;

export type IsTypeOfResolverFn<T = {}, TContext = {}> = (obj: T, context: TContext, info: GraphQLResolveInfo) => boolean | Promise<boolean>;

export type NextResolverFn<T> = () => Promise<T>;

export type DirectiveResolverFn<TResult = {}, TParent = {}, TContext = {}, TArgs = {}> = (
  next: NextResolverFn<TResult>,
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;


/** Mapping of interface types */
export type ResolversInterfaceTypes<_RefType extends Record<string, unknown>> = {
  Connection: ( CompanyConnection );
  Edge: ( CompanyEdge );
  Node: ( Category ) | ( Company ) | ( Context ) | ( Evaluation ) | ( Location ) | ( Participant ) | ( Question ) | ( ScheduledSession ) | ( ScheduledSessionParticipantEntry ) | ( Session ) | ( SessionReport );
  SanityArrayElement: never;
  SanityDocument: ( Company ) | ( Organization ) | ( ScheduledSession ) | ( ScheduledSessionParticipantEntry );
  SanityReference: ( SanityBaseRef );
};

/** Mapping between all available schema types and the resolvers types */
export type ResolversTypes = {
  Address: ResolverTypeWrapper<Address>;
  Answer: ResolverTypeWrapper<Answer>;
  AnswerInput: AnswerInput;
  AuthMode: AuthMode;
  Boolean: ResolverTypeWrapper<Scalars['Boolean']['output']>;
  Category: ResolverTypeWrapper<Category>;
  CloudinaryUploadSignature: ResolverTypeWrapper<CloudinaryUploadSignature>;
  Company: ResolverTypeWrapper<Company>;
  CompanyConnection: ResolverTypeWrapper<CompanyConnection>;
  CompanyEdge: ResolverTypeWrapper<CompanyEdge>;
  CompleteOtpLoginResponse: ResolverTypeWrapper<CompleteOtpLoginResponse>;
  Connection: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['Connection']>;
  Context: ResolverTypeWrapper<Context>;
  CookieValue: ResolverTypeWrapper<CookieValue>;
  CookieValueInput: CookieValueInput;
  CreateOrganizationInput: CreateOrganizationInput;
  Edge: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['Edge']>;
  ErrorCodes: ErrorCodes;
  Evaluation: ResolverTypeWrapper<Evaluation>;
  EvaluationOptions: ResolverTypeWrapper<EvaluationOptions>;
  Float: ResolverTypeWrapper<Scalars['Float']['output']>;
  ID: ResolverTypeWrapper<Scalars['ID']['output']>;
  Int: ResolverTypeWrapper<Scalars['Int']['output']>;
  JSON: ResolverTypeWrapper<Scalars['JSON']['output']>;
  JSONObject: ResolverTypeWrapper<Scalars['JSONObject']['output']>;
  Location: ResolverTypeWrapper<Location>;
  LogoutResponse: ResolverTypeWrapper<LogoutResponse>;
  Mutation: ResolverTypeWrapper<{}>;
  Node: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['Node']>;
  Organization: ResolverTypeWrapper<Organization>;
  PageInfo: ResolverTypeWrapper<PageInfo>;
  Participant: ResolverTypeWrapper<Participant>;
  ParticipantSessionStatus: ParticipantSessionStatus;
  Query: ResolverTypeWrapper<{}>;
  Question: ResolverTypeWrapper<Question>;
  QuestionOptions: ResolverTypeWrapper<QuestionOptions>;
  QuestionStep: ResolverTypeWrapper<QuestionStep>;
  QuestionStepType: QuestionStepType;
  RealtimeToken: ResolverTypeWrapper<RealtimeToken>;
  SanityArrayElement: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['SanityArrayElement']>;
  SanityAssetRef: ResolverTypeWrapper<SanityAssetRef>;
  SanityAssetRefInput: SanityAssetRefInput;
  SanityBaseRef: ResolverTypeWrapper<SanityBaseRef>;
  SanityDocument: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['SanityDocument']>;
  SanityImage: ResolverTypeWrapper<SanityImage>;
  SanityImageInput: SanityImageInput;
  SanityReference: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['SanityReference']>;
  ScheduledSession: ResolverTypeWrapper<ScheduledSession>;
  ScheduledSessionOptions: ResolverTypeWrapper<ScheduledSessionOptions>;
  ScheduledSessionParticipantEntry: ResolverTypeWrapper<ScheduledSessionParticipantEntry>;
  ScheduledSessionParticipantEntryAnswer: ResolverTypeWrapper<ScheduledSessionParticipantEntryAnswer>;
  ScheduledSessionParticipantEntryCurrentState: ResolverTypeWrapper<ScheduledSessionParticipantEntryCurrentState>;
  ScheduledSessionParticipantEntryOverride: ResolverTypeWrapper<ScheduledSessionParticipantEntryOverride>;
  ScheduledSessionParticipantEntryOverrideValue: ResolverTypeWrapper<ScheduledSessionParticipantEntryOverrideValue>;
  ScheduledSessionParticipantEntryProgress: ResolverTypeWrapper<ScheduledSessionParticipantEntryProgress>;
  ScheduledSessionStatus: ScheduledSessionStatus;
  SendErrorReportInput: SendErrorReportInput;
  SendErrorReportResponse: ResolverTypeWrapper<SendErrorReportResponse>;
  SendErrorReportUser: SendErrorReportUser;
  Session: ResolverTypeWrapper<Session>;
  SessionOverrideType: SessionOverrideType;
  SessionReport: ResolverTypeWrapper<SessionReport>;
  SignupParticipantInput: SignupParticipantInput;
  String: ResolverTypeWrapper<Scalars['String']['output']>;
  Unknown: ResolverTypeWrapper<Scalars['Unknown']['output']>;
  UserIdentifierInput: UserIdentifierInput;
  UserIdentifierType: UserIdentifierType;
  UserType: UserType;
};

/** Mapping between all available schema types and the resolvers parents */
export type ResolversParentTypes = {
  Address: Address;
  Answer: Answer;
  AnswerInput: AnswerInput;
  Boolean: Scalars['Boolean']['output'];
  Category: Category;
  CloudinaryUploadSignature: CloudinaryUploadSignature;
  Company: Company;
  CompanyConnection: CompanyConnection;
  CompanyEdge: CompanyEdge;
  CompleteOtpLoginResponse: CompleteOtpLoginResponse;
  Connection: ResolversInterfaceTypes<ResolversParentTypes>['Connection'];
  Context: Context;
  CookieValue: CookieValue;
  CookieValueInput: CookieValueInput;
  CreateOrganizationInput: CreateOrganizationInput;
  Edge: ResolversInterfaceTypes<ResolversParentTypes>['Edge'];
  Evaluation: Evaluation;
  EvaluationOptions: EvaluationOptions;
  Float: Scalars['Float']['output'];
  ID: Scalars['ID']['output'];
  Int: Scalars['Int']['output'];
  JSON: Scalars['JSON']['output'];
  JSONObject: Scalars['JSONObject']['output'];
  Location: Location;
  LogoutResponse: LogoutResponse;
  Mutation: {};
  Node: ResolversInterfaceTypes<ResolversParentTypes>['Node'];
  Organization: Organization;
  PageInfo: PageInfo;
  Participant: Participant;
  Query: {};
  Question: Question;
  QuestionOptions: QuestionOptions;
  QuestionStep: QuestionStep;
  RealtimeToken: RealtimeToken;
  SanityArrayElement: ResolversInterfaceTypes<ResolversParentTypes>['SanityArrayElement'];
  SanityAssetRef: SanityAssetRef;
  SanityAssetRefInput: SanityAssetRefInput;
  SanityBaseRef: SanityBaseRef;
  SanityDocument: ResolversInterfaceTypes<ResolversParentTypes>['SanityDocument'];
  SanityImage: SanityImage;
  SanityImageInput: SanityImageInput;
  SanityReference: ResolversInterfaceTypes<ResolversParentTypes>['SanityReference'];
  ScheduledSession: ScheduledSession;
  ScheduledSessionOptions: ScheduledSessionOptions;
  ScheduledSessionParticipantEntry: ScheduledSessionParticipantEntry;
  ScheduledSessionParticipantEntryAnswer: ScheduledSessionParticipantEntryAnswer;
  ScheduledSessionParticipantEntryCurrentState: ScheduledSessionParticipantEntryCurrentState;
  ScheduledSessionParticipantEntryOverride: ScheduledSessionParticipantEntryOverride;
  ScheduledSessionParticipantEntryOverrideValue: ScheduledSessionParticipantEntryOverrideValue;
  ScheduledSessionParticipantEntryProgress: ScheduledSessionParticipantEntryProgress;
  SendErrorReportInput: SendErrorReportInput;
  SendErrorReportResponse: SendErrorReportResponse;
  SendErrorReportUser: SendErrorReportUser;
  Session: Session;
  SessionReport: SessionReport;
  SignupParticipantInput: SignupParticipantInput;
  String: Scalars['String']['output'];
  Unknown: Scalars['Unknown']['output'];
  UserIdentifierInput: UserIdentifierInput;
};

export type AddressResolvers<ContextType = any, ParentType extends ResolversParentTypes['Address'] = ResolversParentTypes['Address']> = {
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  country?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  line1?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  postal?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  region?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AnswerResolvers<ContextType = any, ParentType extends ResolversParentTypes['Answer'] = ResolversParentTypes['Answer']> = {
  blocklistValue?: Resolver<Maybe<Array<ResolversTypes['JSONObject']>>, ParentType, ContextType>;
  booleanValue?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  booleanlistValue?: Resolver<Maybe<Array<ResolversTypes['Boolean']>>, ParentType, ContextType>;
  numericValue?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  numericlistValue?: Resolver<Maybe<Array<ResolversTypes['Float']>>, ParentType, ContextType>;
  textValue?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  textlistValue?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CategoryResolvers<ContextType = any, ParentType extends ResolversParentTypes['Category'] = ResolversParentTypes['Category']> = {
  _id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  parent?: Resolver<Maybe<ResolversTypes['Category']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CloudinaryUploadSignatureResolvers<ContextType = any, ParentType extends ResolversParentTypes['CloudinaryUploadSignature'] = ResolversParentTypes['CloudinaryUploadSignature']> = {
  public_id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  signature?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  timestamp?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CompanyResolvers<ContextType = any, ParentType extends ResolversParentTypes['Company'] = ResolversParentTypes['Company']> = {
  _createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  _id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  _rev?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  _type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  _updatedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CompanyConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CompanyConnection'] = ResolversParentTypes['CompanyConnection']> = {
  edges?: Resolver<Maybe<Array<ResolversTypes['CompanyEdge']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CompanyEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['CompanyEdge'] = ResolversParentTypes['CompanyEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Company'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CompleteOtpLoginResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['CompleteOtpLoginResponse'] = ResolversParentTypes['CompleteOtpLoginResponse']> = {
  cookies?: Resolver<Maybe<Array<ResolversTypes['CookieValue']>>, ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['Connection'] = ResolversParentTypes['Connection']> = {
  __resolveType: TypeResolveFn<'CompanyConnection', ParentType, ContextType>;
  edges?: Resolver<Maybe<Array<ResolversTypes['Edge']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
};

export type ContextResolvers<ContextType = any, ParentType extends ResolversParentTypes['Context'] = ResolversParentTypes['Context']> = {
  _id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CookieValueResolvers<ContextType = any, ParentType extends ResolversParentTypes['CookieValue'] = ResolversParentTypes['CookieValue']> = {
  expires?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  path?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sameSite?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  secure?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['Edge'] = ResolversParentTypes['Edge']> = {
  __resolveType: TypeResolveFn<'CompanyEdge', ParentType, ContextType>;
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Node'], ParentType, ContextType>;
};

export type EvaluationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Evaluation'] = ResolversParentTypes['Evaluation']> = {
  _id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  categories?: Resolver<Maybe<Array<ResolversTypes['SanityBaseRef']>>, ParentType, ContextType>;
  context?: Resolver<Maybe<ResolversTypes['SanityBaseRef']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  options?: Resolver<Maybe<ResolversTypes['EvaluationOptions']>, ParentType, ContextType>;
  questions?: Resolver<Maybe<Array<ResolversTypes['SanityBaseRef']>>, ParentType, ContextType>;
  rCategories?: Resolver<Maybe<Array<ResolversTypes['Category']>>, ParentType, ContextType>;
  rContext?: Resolver<Maybe<ResolversTypes['Context']>, ParentType, ContextType>;
  rQuestions?: Resolver<Maybe<Array<ResolversTypes['Question']>>, ParentType, ContextType>;
  totalMaxTime?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EvaluationOptionsResolvers<ContextType = any, ParentType extends ResolversParentTypes['EvaluationOptions'] = ResolversParentTypes['EvaluationOptions']> = {
  enableTimer?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface JsonScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['JSON'], any> {
  name: 'JSON';
}

export interface JsonObjectScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['JSONObject'], any> {
  name: 'JSONObject';
}

export type LocationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Location'] = ResolversParentTypes['Location']> = {
  _id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  address?: Resolver<Maybe<ResolversTypes['Address']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LogoutResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['LogoutResponse'] = ResolversParentTypes['LogoutResponse']> = {
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Mutation'] = ResolversParentTypes['Mutation']> = {
  answerEvaluationQuestionStep?: Resolver<Maybe<ResolversTypes['ScheduledSessionParticipantEntry']>, ParentType, ContextType, RequireFields<MutationAnswerEvaluationQuestionStepArgs, 'answer' | 'evaluation' | 'question' | 'stepIndex'>>;
  applyCookie?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType, Partial<MutationApplyCookieArgs>>;
  completeAndCloseQuestionOrEvaluation?: Resolver<Maybe<ResolversTypes['ScheduledSessionParticipantEntry']>, ParentType, ContextType, RequireFields<MutationCompleteAndCloseQuestionOrEvaluationArgs, 'evaluation'>>;
  completeOtpLogin?: Resolver<Maybe<ResolversTypes['CompleteOtpLoginResponse']>, ParentType, ContextType, RequireFields<MutationCompleteOtpLoginArgs, 'loginCode' | 'otp' | 'tenant' | 'userIdentifier'>>;
  completeSessionReportLogin?: Resolver<Maybe<ResolversTypes['SessionReport']>, ParentType, ContextType, RequireFields<MutationCompleteSessionReportLoginArgs, 'accessCode' | 'id'>>;
  continueSession?: Resolver<Maybe<ResolversTypes['ScheduledSessionParticipantEntry']>, ParentType, ContextType, Partial<MutationContinueSessionArgs>>;
  createOrganization?: Resolver<Maybe<ResolversTypes['Organization']>, ParentType, ContextType, RequireFields<MutationCreateOrganizationArgs, 'input'>>;
  getRealtimeToken?: Resolver<Maybe<ResolversTypes['RealtimeToken']>, ParentType, ContextType, Partial<MutationGetRealtimeTokenArgs>>;
  logout?: Resolver<ResolversTypes['LogoutResponse'], ParentType, ContextType>;
  readyScheduledSession?: Resolver<Maybe<ResolversTypes['ScheduledSessionParticipantEntry']>, ParentType, ContextType>;
  requestCloudinaryUploadSignature?: Resolver<Maybe<ResolversTypes['CloudinaryUploadSignature']>, ParentType, ContextType>;
  requestHelp?: Resolver<Maybe<ResolversTypes['ScheduledSessionParticipantEntry']>, ParentType, ContextType, Partial<MutationRequestHelpArgs>>;
  requestLogin?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationRequestLoginArgs, 'loginCode' | 'tenant' | 'userIdentifier'>>;
  sendErrorReport?: Resolver<ResolversTypes['SendErrorReportResponse'], ParentType, ContextType, RequireFields<MutationSendErrorReportArgs, 'input'>>;
  signupForScheduledSession?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationSignupForScheduledSessionArgs, 'loginCode' | 'participant' | 'tenant' | 'userIdentifier'>>;
};

export type NodeResolvers<ContextType = any, ParentType extends ResolversParentTypes['Node'] = ResolversParentTypes['Node']> = {
  __resolveType: TypeResolveFn<'Category' | 'Company' | 'Context' | 'Evaluation' | 'Location' | 'Participant' | 'Question' | 'ScheduledSession' | 'ScheduledSessionParticipantEntry' | 'Session' | 'SessionReport', ParentType, ContextType>;
  _id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
};

export type OrganizationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Organization'] = ResolversParentTypes['Organization']> = {
  _createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  _id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  _rev?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  _type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  _updatedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  auth0_region?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  auth0_tenant?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isActive?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  logo?: Resolver<Maybe<ResolversTypes['SanityImage']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  organizationId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  organizationManagerEmails?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  organizationManagerUsers?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PageInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['PageInfo'] = ResolversParentTypes['PageInfo']> = {
  endCursor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hasNextPage?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  hasPreviousPage?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  pageSize?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  startCursor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  totalCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ParticipantResolvers<ContextType = any, ParentType extends ResolversParentTypes['Participant'] = ResolversParentTypes['Participant']> = {
  _id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  externalId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type QueryResolvers<ContextType = any, ParentType extends ResolversParentTypes['Query'] = ResolversParentTypes['Query']> = {
  allCompanies?: Resolver<ResolversTypes['CompanyConnection'], ParentType, ContextType, RequireFields<QueryAllCompaniesArgs, 'tenant'>>;
  myScheduledSession?: Resolver<Maybe<ResolversTypes['ScheduledSession']>, ParentType, ContextType>;
  myScheduledSessionParticipantEntry?: Resolver<Maybe<ResolversTypes['ScheduledSessionParticipantEntry']>, ParentType, ContextType>;
  organizationTenantExists?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<QueryOrganizationTenantExistsArgs, 'tenant'>>;
};

export type QuestionResolvers<ContextType = any, ParentType extends ResolversParentTypes['Question'] = ResolversParentTypes['Question']> = {
  _id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  categories?: Resolver<Maybe<Array<ResolversTypes['SanityBaseRef']>>, ParentType, ContextType>;
  maxTime?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  options?: Resolver<Maybe<ResolversTypes['QuestionOptions']>, ParentType, ContextType>;
  rCategories?: Resolver<Maybe<Array<ResolversTypes['Category']>>, ParentType, ContextType>;
  steps?: Resolver<Maybe<Array<ResolversTypes['QuestionStep']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type QuestionOptionsResolvers<ContextType = any, ParentType extends ResolversParentTypes['QuestionOptions'] = ResolversParentTypes['QuestionOptions']> = {
  maxTime?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type QuestionStepResolvers<ContextType = any, ParentType extends ResolversParentTypes['QuestionStep'] = ResolversParentTypes['QuestionStep']> = {
  _key?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  answer?: Resolver<Maybe<ResolversTypes['Answer']>, ParentType, ContextType>;
  question?: Resolver<Maybe<Array<ResolversTypes['JSONObject']>>, ParentType, ContextType>;
  score?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['QuestionStepType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RealtimeTokenResolvers<ContextType = any, ParentType extends ResolversParentTypes['RealtimeToken'] = ResolversParentTypes['RealtimeToken']> = {
  capability?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  clientId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  expires?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  issued?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  token?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SanityArrayElementResolvers<ContextType = any, ParentType extends ResolversParentTypes['SanityArrayElement'] = ResolversParentTypes['SanityArrayElement']> = {
  __resolveType: TypeResolveFn<null, ParentType, ContextType>;
  _key?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type SanityAssetRefResolvers<ContextType = any, ParentType extends ResolversParentTypes['SanityAssetRef'] = ResolversParentTypes['SanityAssetRef']> = {
  _ref?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  _type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SanityBaseRefResolvers<ContextType = any, ParentType extends ResolversParentTypes['SanityBaseRef'] = ResolversParentTypes['SanityBaseRef']> = {
  _ref?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  _type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SanityDocumentResolvers<ContextType = any, ParentType extends ResolversParentTypes['SanityDocument'] = ResolversParentTypes['SanityDocument']> = {
  __resolveType: TypeResolveFn<'Company' | 'Organization' | 'ScheduledSession' | 'ScheduledSessionParticipantEntry', ParentType, ContextType>;
  _createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  _id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  _rev?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  _type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  _updatedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type SanityImageResolvers<ContextType = any, ParentType extends ResolversParentTypes['SanityImage'] = ResolversParentTypes['SanityImage']> = {
  _type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  asset?: Resolver<ResolversTypes['SanityAssetRef'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SanityReferenceResolvers<ContextType = any, ParentType extends ResolversParentTypes['SanityReference'] = ResolversParentTypes['SanityReference']> = {
  __resolveType: TypeResolveFn<'SanityBaseRef', ParentType, ContextType>;
  _ref?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  _type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type ScheduledSessionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ScheduledSession'] = ResolversParentTypes['ScheduledSession']> = {
  _createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  _id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  _rev?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  _type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  _updatedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  autoAdvance?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  datetime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  options?: Resolver<Maybe<ResolversTypes['ScheduledSessionOptions']>, ParentType, ContextType>;
  progress?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rLocation?: Resolver<Maybe<ResolversTypes['Location']>, ParentType, ContextType>;
  rSession?: Resolver<Maybe<ResolversTypes['Session']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['ScheduledSessionStatus']>, ParentType, ContextType>;
  timeLeft?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  unlockableParticipantIds?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScheduledSessionOptionsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ScheduledSessionOptions'] = ResolversParentTypes['ScheduledSessionOptions']> = {
  allQuestionsInEvaluationShownByDefault?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  enableAutoPauseOnHelpRequest?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScheduledSessionParticipantEntryResolvers<ContextType = any, ParentType extends ResolversParentTypes['ScheduledSessionParticipantEntry'] = ResolversParentTypes['ScheduledSessionParticipantEntry']> = {
  _createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  _id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  _rev?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  _type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  _updatedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  currentState?: Resolver<Maybe<ResolversTypes['ScheduledSessionParticipantEntryCurrentState']>, ParentType, ContextType>;
  expectedEndTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  participant?: Resolver<Maybe<ResolversTypes['SanityBaseRef']>, ParentType, ContextType>;
  ready?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  reassignedEvaluationId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  sessionAnswers?: Resolver<Maybe<Array<ResolversTypes['ScheduledSessionParticipantEntryAnswer']>>, ParentType, ContextType>;
  sessionOrder?: Resolver<Maybe<Array<ResolversTypes['SanityBaseRef']>>, ParentType, ContextType>;
  sessionOverrides?: Resolver<Maybe<Array<ResolversTypes['ScheduledSessionParticipantEntryOverride']>>, ParentType, ContextType>;
  sessionProgress?: Resolver<Maybe<Array<ResolversTypes['ScheduledSessionParticipantEntryProgress']>>, ParentType, ContextType>;
  sessionStart?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  timeLeft?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScheduledSessionParticipantEntryAnswerResolvers<ContextType = any, ParentType extends ResolversParentTypes['ScheduledSessionParticipantEntryAnswer'] = ResolversParentTypes['ScheduledSessionParticipantEntryAnswer']> = {
  answers?: Resolver<Maybe<Array<ResolversTypes['Answer']>>, ParentType, ContextType>;
  comment?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  evaluation?: Resolver<Maybe<ResolversTypes['SanityBaseRef']>, ParentType, ContextType>;
  question?: Resolver<Maybe<ResolversTypes['SanityBaseRef']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScheduledSessionParticipantEntryCurrentStateResolvers<ContextType = any, ParentType extends ResolversParentTypes['ScheduledSessionParticipantEntryCurrentState'] = ResolversParentTypes['ScheduledSessionParticipantEntryCurrentState']> = {
  _type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  correctedEvaluationIds?: Resolver<Maybe<Array<ResolversTypes['ID']>>, ParentType, ContextType>;
  evaluation?: Resolver<Maybe<ResolversTypes['SanityBaseRef']>, ParentType, ContextType>;
  finishedEvaluationIds?: Resolver<Maybe<Array<ResolversTypes['ID']>>, ParentType, ContextType>;
  isCurrentEvaluationEnded?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isReassigned?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  lastUpdated?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  latestProgress?: Resolver<Maybe<ResolversTypes['ScheduledSessionParticipantEntryProgress']>, ParentType, ContextType>;
  progressPercentage?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  question?: Resolver<Maybe<ResolversTypes['SanityBaseRef']>, ParentType, ContextType>;
  rEvaluation?: Resolver<Maybe<ResolversTypes['Evaluation']>, ParentType, ContextType>;
  rQuestion?: Resolver<Maybe<ResolversTypes['Question']>, ParentType, ContextType>;
  reassignedWithUnsubmittedCorrectionsEvaluationIds?: Resolver<Maybe<Array<ResolversTypes['ID']>>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['ParticipantSessionStatus']>, ParentType, ContextType>;
  stepIndex?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  totalEvaluationsCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScheduledSessionParticipantEntryOverrideResolvers<ContextType = any, ParentType extends ResolversParentTypes['ScheduledSessionParticipantEntryOverride'] = ResolversParentTypes['ScheduledSessionParticipantEntryOverride']> = {
  datetime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  evaluation?: Resolver<Maybe<ResolversTypes['SanityBaseRef']>, ParentType, ContextType>;
  overrideType?: Resolver<Maybe<ResolversTypes['SessionOverrideType']>, ParentType, ContextType>;
  question?: Resolver<Maybe<ResolversTypes['SanityBaseRef']>, ParentType, ContextType>;
  rEvaluation?: Resolver<Maybe<ResolversTypes['Evaluation']>, ParentType, ContextType>;
  rQuestion?: Resolver<Maybe<ResolversTypes['Question']>, ParentType, ContextType>;
  stepIndex?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['ScheduledSessionParticipantEntryOverrideValue']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScheduledSessionParticipantEntryOverrideValueResolvers<ContextType = any, ParentType extends ResolversParentTypes['ScheduledSessionParticipantEntryOverrideValue'] = ResolversParentTypes['ScheduledSessionParticipantEntryOverrideValue']> = {
  numericValue?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  textValue?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScheduledSessionParticipantEntryProgressResolvers<ContextType = any, ParentType extends ResolversParentTypes['ScheduledSessionParticipantEntryProgress'] = ResolversParentTypes['ScheduledSessionParticipantEntryProgress']> = {
  evaluation?: Resolver<Maybe<ResolversTypes['SanityBaseRef']>, ParentType, ContextType>;
  question?: Resolver<Maybe<ResolversTypes['SanityBaseRef']>, ParentType, ContextType>;
  rEvaluation?: Resolver<Maybe<ResolversTypes['Evaluation']>, ParentType, ContextType>;
  rQuestion?: Resolver<Maybe<ResolversTypes['Question']>, ParentType, ContextType>;
  sectionEnd?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sectionStart?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  timestamp?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SendErrorReportResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['SendErrorReportResponse'] = ResolversParentTypes['SendErrorReportResponse']> = {
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SessionResolvers<ContextType = any, ParentType extends ResolversParentTypes['Session'] = ResolversParentTypes['Session']> = {
  _id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rCategories?: Resolver<Maybe<Array<ResolversTypes['Category']>>, ParentType, ContextType>;
  rEvaluations?: Resolver<Maybe<Array<ResolversTypes['Evaluation']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SessionReportResolvers<ContextType = any, ParentType extends ResolversParentTypes['SessionReport'] = ResolversParentTypes['SessionReport']> = {
  _id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  accessCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cookies?: Resolver<Maybe<Array<ResolversTypes['CookieValue']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface UnknownScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Unknown'], any> {
  name: 'Unknown';
}

export type Resolvers<ContextType = any> = {
  Address?: AddressResolvers<ContextType>;
  Answer?: AnswerResolvers<ContextType>;
  Category?: CategoryResolvers<ContextType>;
  CloudinaryUploadSignature?: CloudinaryUploadSignatureResolvers<ContextType>;
  Company?: CompanyResolvers<ContextType>;
  CompanyConnection?: CompanyConnectionResolvers<ContextType>;
  CompanyEdge?: CompanyEdgeResolvers<ContextType>;
  CompleteOtpLoginResponse?: CompleteOtpLoginResponseResolvers<ContextType>;
  Connection?: ConnectionResolvers<ContextType>;
  Context?: ContextResolvers<ContextType>;
  CookieValue?: CookieValueResolvers<ContextType>;
  Edge?: EdgeResolvers<ContextType>;
  Evaluation?: EvaluationResolvers<ContextType>;
  EvaluationOptions?: EvaluationOptionsResolvers<ContextType>;
  JSON?: GraphQLScalarType;
  JSONObject?: GraphQLScalarType;
  Location?: LocationResolvers<ContextType>;
  LogoutResponse?: LogoutResponseResolvers<ContextType>;
  Mutation?: MutationResolvers<ContextType>;
  Node?: NodeResolvers<ContextType>;
  Organization?: OrganizationResolvers<ContextType>;
  PageInfo?: PageInfoResolvers<ContextType>;
  Participant?: ParticipantResolvers<ContextType>;
  Query?: QueryResolvers<ContextType>;
  Question?: QuestionResolvers<ContextType>;
  QuestionOptions?: QuestionOptionsResolvers<ContextType>;
  QuestionStep?: QuestionStepResolvers<ContextType>;
  RealtimeToken?: RealtimeTokenResolvers<ContextType>;
  SanityArrayElement?: SanityArrayElementResolvers<ContextType>;
  SanityAssetRef?: SanityAssetRefResolvers<ContextType>;
  SanityBaseRef?: SanityBaseRefResolvers<ContextType>;
  SanityDocument?: SanityDocumentResolvers<ContextType>;
  SanityImage?: SanityImageResolvers<ContextType>;
  SanityReference?: SanityReferenceResolvers<ContextType>;
  ScheduledSession?: ScheduledSessionResolvers<ContextType>;
  ScheduledSessionOptions?: ScheduledSessionOptionsResolvers<ContextType>;
  ScheduledSessionParticipantEntry?: ScheduledSessionParticipantEntryResolvers<ContextType>;
  ScheduledSessionParticipantEntryAnswer?: ScheduledSessionParticipantEntryAnswerResolvers<ContextType>;
  ScheduledSessionParticipantEntryCurrentState?: ScheduledSessionParticipantEntryCurrentStateResolvers<ContextType>;
  ScheduledSessionParticipantEntryOverride?: ScheduledSessionParticipantEntryOverrideResolvers<ContextType>;
  ScheduledSessionParticipantEntryOverrideValue?: ScheduledSessionParticipantEntryOverrideValueResolvers<ContextType>;
  ScheduledSessionParticipantEntryProgress?: ScheduledSessionParticipantEntryProgressResolvers<ContextType>;
  SendErrorReportResponse?: SendErrorReportResponseResolvers<ContextType>;
  Session?: SessionResolvers<ContextType>;
  SessionReport?: SessionReportResolvers<ContextType>;
  Unknown?: GraphQLScalarType;
};

